import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { CSRF_PATH } from 'src/app/constants/NextGenConstants';
import { v4 as uuidv4 } from 'uuid';

/**
 * csrfService handles fetching and storing the CSRF token for secure HTTP requests.
 */
@Injectable({
  providedIn: 'root',
})
export class CsrfService {
  private csrfToken: string | null = null;

  constructor(private readonly http: HttpClient) {}

  getCsrfToken(): Observable<string> {
    if (this.csrfToken) {
      return of(this.csrfToken);
    }
    return this.http
      .get<{
        parameterName: string;
        token: string;
        headerName: string;
      }>(CSRF_PATH, { headers: this.contentTypeHeader })
      .pipe(
        map((response) => {
          this.csrfToken = response.token;
          return this.csrfToken;
        }),
        shareReplay(1), // cache the observable until next refresh
        catchError(() => {
          return of('');
        }),
      );
  }

  //used to clear the token on logout
  clearToken() {
    this.csrfToken = null;
  }

  setTokenTestUUID(uuid: string) {
    this.csrfToken = uuid;
  }

  /**
   * Returns HTTP headers with content type and a unique tracking ID.
   */
  private get contentTypeHeader(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'FID-LOG-TRACKING-ID': uuidv4(),
    });
  }
}
